import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BlankState from '../../../components/BlankState';
import StatusMessages2 from '../../../components/StatusMessages2';

import { saveBroker, updateBroker } from '../../../actions/brokers';

import SimpleReactValidator from 'simple-react-validator';
import Cleave from 'cleave.js/react';


class BrokerAgencyForm extends Component{

    constructor(props){
        super(props);

        this.validator=new SimpleReactValidator();

        this.state = {
            broker: {
                ...this.props.broker
            },
            broker_loading: false
        };
    }

    componentWillReceiveProps(nextProps){
        const { broker } = nextProps;

        this.setState({
            broker: broker || {},
            updated_broker: {
                id: broker ? broker.id : ''
            },
        });
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.setState({ broker_loading: true });

        if(this.validator.allValid()){
            this.validator.hideMessages();
            const { broker, updated_broker } = this.state;
            let handler = {};

            if(broker.hasOwnProperty('id')){
                handler = this.props.updateBroker(updated_broker);
            }
            else{
                handler = this.props.saveBroker(broker);
            }

            handler
                .then((response)=>{
                    this.setState({ broker_loading: false });
                })
                .catch((error)=>{
                    this.setState({ broker_loading: false });
                });
        } else{
            this.validator.showMessages();
            this.forceUpdate();
            this.setState({ broker_loading: false });
        }
        
    }

    onChange = (e) => {
        e.preventDefault();

        const { updated_broker, broker } = this.state;
        const { name, value } = e.target;

        this.setState({ 
            updated_broker: {
                ...updated_broker,
                [name]: value
            },
            broker: {
                ...broker,
                [name]: value
            },
        });
    }

    render(){
        const { broker, broker_loading } = this.state;
        const { brokers } = this.props;
        const { edit } = this.props; 
        return(
            <form 
                className="form-horizontal" 
                noValidate
                onSubmit={ this.onSubmit }>
                
                {
                    brokers.errorCreateBroker && edit && !broker_loading ?
                        <StatusMessages2 
                            type="error"
                            message={ brokers.errorMessageCreateBroker } />
                    :
                        null
                }
                {
                    brokers.success ?
                        <StatusMessages2 
                            type="success" 
                            message={ brokers.successMessage } />
                    : null
                }
                <BlankState
                    data={ false }
                    customMessage="Saving details..."
                    isDataLoading={ broker_loading } />

                <div className="form-group">
                    <label className="col-sm-4 control-label">Name: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            className="form-control" 
                            name="name"
                            value={ broker.name || '' }
                            onChange={ this.onChange }  />
                        {this.validator.message('name',broker.name, 'required', 'text-danger')}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Type: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <select 
                            className="form-control" 
                            name="intermediary_type" 
                            value={ broker.intermediary_type || '' }
                            onChange={ this.onChange }>

                            <option value="" disabled>Select Intermediary Type</option>
                            <option value="BROKERAGE">BROKERAGE</option>
                            <option value="AGENCY">AGENCY</option>
                        </select>
                        {this.validator.message('intermediary_type',broker.intermediary_type, 'required', 'text-danger')}
                    </div>
                </div>


                <div className="form-group">
                    <label className="col-sm-4 control-label">Phone Number: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="number" 
                            className="form-control" 
                            name="phone" 
                            required
                            value={ broker.phone || '' }
                            onChange={ this.onChange } />
                        {this.validator.message('phone',broker.phone, 'required', 'text-danger')}                            
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Postal Address: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="postal_address" 
                            className="form-control" 
                            value={ broker.postal_address || '' }
                            onChange={ this.onChange }  />
                    {this.validator.message('postal_address',broker.postal_address, 'required', 'text-danger')} 
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Tax Identification Number(TIN): <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <Cleave options={
                            {blocks: [3,3,4],
                                delimiter: '-',
                                numericOnly: true }
                            }
                            className="form-control"
                            name="tra_pin"
                            label="Tax Payer PIN" 
                            placeholder="Tax Payer PIN" 
                            type="text"
                            value={ broker.tra_pin || '' }
                            onChange={this.onChange}/>
                        {this.validator.message('tra_pin',broker.tra_pin, 'required', 'text-danger')} 
                    </div>
                </div>

                <div className="form-group">
                    <label className="control-label col-sm-4">TIRA Registration No: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            className="form-control" 
                            name="ira_reg" 
                            value={ broker.ira_reg || ''  }
                            onChange={ this.onChange } />
                            {this.validator.message('ira_reg',broker.ira_reg, 'required', 'text-danger')} 
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Email: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="email" 
                            className="form-control" 
                            name="email"
                            value={ broker.email || '' }
                            onChange={ this.onChange } />
                        {this.validator.message('email',broker.email, 'required', 'text-danger')} 
                    </div>
                </div>

                <div className="col-sm-offset-4">
                    <div className="col-sm-12">
                    {
                        broker.hasOwnProperty('id') ?
                            <button className="btn btn-warning" >
                                <i className="icon ion-edit"></i>&nbsp; Update Broker Agency
                            </button>
                        :
                            <button className="btn btn-success">
                                <i className="icon ion-checkmark"></i>&nbsp; Create Broker Agency
                            </button>
                    }
                    </div>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    brokers: state.brokers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ saveBroker, updateBroker }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BrokerAgencyForm);


// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/BrokerAgencyForm.jsx